module.exports = __webpack_public_path__ + "static/media/rogova.15598ea2.jpg";